// extracted by mini-css-extract-plugin
module.exports = {"BannerModule":"BannerModule_BannerModule__LcsPD"};